import { render } from "./LoggedInLayout.vue?vue&type=template&id=32949137"
import script from "./LoggedInLayout.vue?vue&type=script&lang=js"
export * from "./LoggedInLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__